import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { SalaryUncheckedReasonValues } from 'app/constants/salaryReconciliations';

import { SalaryReconciliationUncheckedIndividual } from 'app/types/salaryReconciliations';

/**
 * @description Columns of the individuals a salary accrual reconciliation run could not check. The company column is
 * left out in a company's own view.
 */
function getSalaryUncheckedIndividualColumns(showCompanyColumn = true) {
  const columnHelper = createColumnHelper<SalaryReconciliationUncheckedIndividual>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const columns: ColumnDef<SalaryReconciliationUncheckedIndividual, any>[] = [
    columnHelper.accessor('companyName', {
      id: 'company',
      header: 'Company',
      enableSorting: false,
      cell: (info) => info.getValue() || '-',
    }),
    columnHelper.accessor('individualName', {
      header: 'Person',
      enableSorting: false,
      cell: (info) => info.getValue() || '-',
    }),
    columnHelper.accessor('externalPayrollId', {
      header: 'Payroll ID',
      enableSorting: false,
      cell: (info) => info.getValue() || '-',
    }),
    columnHelper.accessor('reason', {
      header: 'Why it was not checked',
      enableSorting: false,
      cell: (info) => SalaryUncheckedReasonValues[info.row.original.reason] ?? info.getValue(),
    }),
  ];

  return showCompanyColumn ? columns : columns.filter((column) => column.id !== 'company');
}

export default getSalaryUncheckedIndividualColumns;
